import axios from 'axios';

export class PopUpService {
  static fetchUserNotificationOptions() {
    return axios
      .post(
        '/p/oneapp/client/api/getUserOptions',
        `payload=${JSON.stringify({
          optionNames: [
            'WebMessage.noti.option.show',
            'WebMessage.noti.option.showStyle',
            'Web.messageNotiOn',
            'Web.mailNotiOn',
            'Web.serviceNotiOn',
            'NO_PC_PUSH',
            'SMART_MUTE',
          ],
        })}`,
      )
      .then(({ data }) => {
        const { userOptions } = data;
        const options = {
          subscribed: true,
          contentPreviewed: true,
          pausedPlatforms: {
            desktopApp: false,
            mobileApp: false,
          },
          subscribedServices: {
            service: true,
            message: true,
            mail: true,
            calendar: true,
            home: true,
            task: true,
          },
        };

        return userOptions.reduce((options, option) => {
          const { optionName, optionValue } = option;

          switch (optionName) {
            case 'WebMessage.noti.option.show': {
              options.subscribed = optionValue === 'true';
              break;
            }
            case 'WebMessage.noti.option.showStyle': {
              options.contentPreviewed = optionValue === 'header-body';
              break;
            }
            case 'Web.serviceNotiOn': {
              options.subscribedServices.service = optionValue === 'true';
              break;
            }
            case 'Web.messageNotiOn': {
              options.subscribedServices.message = optionValue === 'true';
              break;
            }
            case 'Web.mailNotiOn': {
              options.subscribedServices.mail = optionValue === 'true';
              break;
            }
            case 'Web.calendarNotiOn': {
              options.subscribedServices.calendar = optionValue === 'true';
              break;
            }
            case 'Web.homeNotiOn': {
              options.subscribedServices.home = optionValue === 'true';
              break;
            }
            case 'Web.taskNotiOn': {
              options.subscribedServices.task = optionValue === 'true';
              break;
            }
            case 'NO_PC_PUSH': {
              options.pausedPlatforms.desktopApp = optionValue === '1';
              break;
            }
            case 'SMART_MUTE': {
              options.pausedPlatforms.mobileApp = optionValue === '1';
              break;
            }
            default:
              break;
          }

          return options;
        }, options);
      })
      .catch(() => {});
  }

  static saveUserNotificationOptions(settings) {
    const userOptions = [
      {
        optionName: 'WebMessage.noti.option.show',
        optionValue: settings.subscribed ? 'true' : 'false',
      },
      {
        optionName: 'WebMessage.noti.option.showStyle',
        optionValue: settings.contentPreviewed ? 'header-body' : 'header',
      },
      {
        optionName: 'NO_PC_PUSH',
        optionValue: settings.pausedPlatforms.desktopApp ? '1' : '0',
      },
      {
        optionName: 'SMART_MUTE',
        optionValue: settings.pausedPlatforms.mobileApp ? '1' : '0',
      },
      {
        optionName: 'Web.serviceNotiOn',
        optionValue: settings.subscribedServices.service ? 'true' : 'false',
      },
      {
        optionName: 'Web.messageNotiOn',
        optionValue: settings.subscribedServices.message ? 'true' : 'false',
      },
      {
        optionName: 'Web.mailNotiOn',
        optionValue: settings.subscribedServices.mail ? 'true' : 'false',
      },
    ];

    return axios
      .post(
        '/p/oneapp/client/api/setUserOptions',
        `payload={"userOptions":${JSON.stringify(userOptions)}}`,
      )
      .then(({ data }) => data);
  }
}
